import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SearchType } from '../../features/search/search.types';
interface SearchState {
  consumers: SearchType | null;
}

const initialState: SearchState = {
  consumers: null,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateConsumersSearch: (state, action: PayloadAction<SearchType>) => {
      state.consumers = action.payload;
    },
    clearConsumersSearch: (state) => {
      state.consumers = null;
    },
  },
});

export const { updateConsumersSearch, clearConsumersSearch } = searchSlice.actions;
export default searchSlice.reducer;
